import React, { FC } from 'react'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import { makeStyles } from '@material-ui/styles'
import SimpleLink from './SimpleLink'
import Theme from 'core/themes/model'
import Tooltip from 'core/elements/tooltip'
import { topLeft } from 'core/elements/menu/defaults'
import colors from 'core/themes/base/colors'

interface Props {
  title?: string | (() => React.ReactNode)
  icon?: string
  color?: string
  link?: string
}

const colorMap = {
  white: '100',
  black: '700',
}

type IIconColor = Props['color']

const useStyles = makeStyles<Theme, { color: IIconColor; isLink: boolean }>((theme: Theme) => ({
  icon: {
    cursor: ({ isLink }) => (isLink ? 'pointer' : 'default'),
    fontWeight: 300,
    color: ({ color }) => (color ? theme.palette.grey[colorMap[color]] : colors.grey[300]),
    '&:hover': {
      color: theme.palette.grey[700],
    },
  },
}))

const HelpContainer: FC<Props> = ({
  title = 'Help',
  icon = 'info-circle',
  color = '',
  link = undefined,
}) => {
  const classes = useStyles({ color, isLink: !!link })

  const content = link ? (
    <SimpleLink src={link}>
      <FontAwesomeIcon className={classes.icon}>{icon}</FontAwesomeIcon>
    </SimpleLink>
  ) : (
    <FontAwesomeIcon className={classes.icon}>{icon}</FontAwesomeIcon>
  )

  if (typeof title === 'function') {
    const tooltipContent = title()
    return <Tooltip customBody={tooltipContent}>{content}</Tooltip>
  }

  return <Tooltip message={title}>{content}</Tooltip>
}

export default HelpContainer
